<div class="menu-bar-container">
  <app-nav-bar-template [logoLink]="customer.www" [logoImageSrc]="customer.logo">
    @if (loggedIn | async) {
    <app-nav-bar-button label="Patients" [routerLink]="patientsPath" />
    }
    @if ((loggedIn | async) && (isAdmin | async)) {
    <app-nav-bar-button class="p-button-text" label="Students" [routerLink]="studentsPath" />
    <app-nav-bar-button label="Medications" [routerLink]="medicationsPath" />
    }
    <app-nav-bar-button label="About" [routerLink]="aboutUsPath" />
    @if(loggedIn | async) {
    <app-nav-bar-split-button label="Profile" icon="pi pi-user" [defaultRouterLink]="settingsPath"
      [model]="profileItems" />
    }
  </app-nav-bar-template>
  <router-outlet></router-outlet>
</div>